"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreContainer = void 0;
/**
 * Wraps an object containing MobX stores to all for
 * typed access.
 */
var StoreContainer = /** @class */ (function () {
    /**
     * Constructs a new `StoreContainer` from an object
     * containing stores.
     *
     * @param stores A `Stores` object.
     */
    function StoreContainer(stores) {
        this.stores = stores;
    }
    /**
     * Retrieves an individual store from the container.
     *
     * @param name The name of the store.
     */
    StoreContainer.prototype.get = function (name) {
        return this.stores[name];
    };
    return StoreContainer;
}());
exports.StoreContainer = StoreContainer;
//# sourceMappingURL=store-container.js.map